import { type FC } from 'react'
import { PageWithRefresh } from '@dhl-ui/page'
import { type PageProps, Page as ReceiverPage } from '@dhl/receiver-page'

export const OnboardingShellPage: FC<PageProps> = ({ children, ...props }) => (
  <ReceiverPage header={<PageWithRefresh.Header />} {...props}>
    {children}
  </ReceiverPage>
)
